import * as actions from './index';

export const addRequestCourse = (data = {}) => {
    return {
        type: actions.ADD_REQUEST_COURSE_FORM,
        payload: {
            data,
            url: 'new-course-request/',
            onSuccess: actions.ADD_REQUEST_COURSE_FORM_SUCCEEDED,
            onFailure: actions.ADD_REQUEST_COURSE_FORM_FAILED
        }
    }
}

export const getTutorDetail = (username = {}) => {
    return {
        type: actions.GET_TUTOR_DETAIL,
        payload: {
            url: `instructor-list/${username}`,
            onSuccess: actions.GET_TUTOR_DETAIL_SUCCEEDED,
            onFailure: actions.GET_TUTOR_DETAIL_FAILED
        }
    };
};

export const getTutorTermsConditions = () => {
  return {
    type: actions.GET_TUTOR_TERMS_CONDITIONS,
    payload: {
      url: `terms-condition/teacher/`,
      onSuccess: actions.GET_TUTOR_TERMS_CONDITIONS_SUCCEEDED,
      onFailure: actions.GET_TUTOR_TERMS_CONDITIONS_FAILED,
    },
  };
};

export const clearTutorState = () => {
    return {
        type: actions.CLEAR_TUTOR_STATE
    }
}

export const setTutorData = (payload) => {
  return {
    type: actions.SET_TUTOR_DATA,
    payload,
  };
};

export const setTutorEditData = (data = {}) => {
  return {
    type: actions.SET_TUTOR_EDIT_DATA,
    payload: {
      data,
    },
  };
};